import React from 'react';
import type { HistoricalRecord } from '../../types';
import { Badge } from '../ui/Badge';
import { formatMetricLabel, formatDateRange } from '../../utils/calculations';
interface HistoryTableProps {
  records: HistoricalRecord[];
}
export function HistoryTable({
  records
}: HistoryTableProps) {
  if (records.length === 0) {
    return <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm px-6 py-12 text-center transition-colors" data-id="element-242">
        <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-243">
          No historical records match the selected filters.
        </p>
      </div>;
  }
  return <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden transition-colors" data-id="element-244">
      <div className="overflow-x-auto" data-id="element-245">
        <table className="w-full text-sm" aria-label="Historical records table" data-id="element-246">
          <thead data-id="element-247">
            <tr className="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700" data-id="element-248">
              <th className="text-left px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-249">
                Period
              </th>
              <th className="text-left px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-250">
                Entity
              </th>
              <th className="text-left px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-251">
                Type
              </th>
              <th className="text-left px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-252">
                Metric
              </th>
              <th className="text-right px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-253">
                Target
              </th>
              <th className="text-right px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-254">
                Actual
              </th>
              <th className="text-right px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-255">
                %
              </th>
              <th className="text-center px-6 py-3.5 font-semibold text-gray-600 dark:text-gray-300 uppercase text-xs tracking-wider" data-id="element-256">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700" data-id="element-257">
            {records.map((record, index) => <tr key={record.id} className={`hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors ${index % 2 === 1 ? 'bg-gray-50/40 dark:bg-gray-700/20' : 'bg-white dark:bg-gray-800'}`} data-id="element-258">
                <td className="px-6 py-4 text-gray-600 dark:text-gray-400 whitespace-nowrap" data-id="element-259">
                  <div data-id="element-260">
                    <span className="capitalize text-xs font-medium text-gray-400 dark:text-gray-500 block mb-0.5" data-id="element-261">
                      {record.periodType}
                    </span>
                    <span className="text-sm text-gray-700 dark:text-gray-300 font-medium" data-id="element-262">
                      {formatDateRange(record.startDate, record.endDate)}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" data-id="element-263">
                  {record.entityName}
                </td>
                <td className="px-6 py-4 text-gray-600 dark:text-gray-400 capitalize" data-id="element-264">
                  {record.entityType}
                </td>
                <td className="px-6 py-4 text-gray-700 dark:text-gray-300 font-medium" data-id="element-265">
                  {formatMetricLabel(record.metric)}
                </td>
                <td className="px-6 py-4 text-right text-gray-600 dark:text-gray-400" data-id="element-266">
                  {record.target}
                </td>
                <td className="px-6 py-4 text-right font-bold text-gray-900 dark:text-white" data-id="element-267">
                  {record.actual}
                </td>
                <td className="px-6 py-4 text-right font-semibold text-gray-700 dark:text-gray-300" data-id="element-268">
                  {record.percentage.toFixed(1)}%
                </td>
                <td className="px-6 py-4 text-center" data-id="element-269">
                  <div className="flex justify-center" data-id="element-270">
                    <Badge status={record.achieved ? 'achieved' : 'missed'} size="sm" data-id="element-271" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}